import { ModalWindow } from '@cian/ui-kit';
import * as React from 'react';

import { IBestPlaceReportModalProps } from './types';

export const BestPlaceReportModal: React.FC<IBestPlaceReportModalProps> = ({ isOpened, onClose, modalContent }) => {
  return <ModalWindow open={isOpened} onClose={onClose} outside={true} content={modalContent} />;
};
